const Strings ={
    somethingWentWrongError: "Something went wrong. Please try again later.",
    //... other strings for the app...
}

export default Strings;